<template>
  <div class="k-dropdown-container">
    <div
      :class="`k-dropdown ${error ? '-error' : ''}`"
      v-click-outside="handleFocusOut"
    >
      <div class="externalOverlay" />
      <div class="c-select-container">
        <div
          class="c-select"
          @click="handleClick"
          @keyup.tab="handleFocusOut"
          tabindex="0"
        >
          <div class="content">
            <label class="label">{{ label }}</label>
            <input
              name="k-input"
              :value="value"
              class="not-display"
              type="text"
              autocomplete="nope"
            />
            <input
              v-if="isOpened"
              :aria-label="placeholder"
              v-model="search"
              ref="search"
              type="text"
              class="dropdown-button"
              autocomplete="nope"
              name="k-input"
            />
            <input
              v-else
              :aria-label="placeholder"
              :value="choosedOption || placeholder"
              type="text"
              class="dropdown-button"
              :class="!choosedOption ? '-placeholder' : ''"
              autocomplete="nope"
              name="k-input"
            />
            <span
              class="false-placeholder"
              v-show="isOpened && search.length === 0"
            >
              {{ placeholder }}
            </span>
          </div>

          <k-icon
            :class="`icon ${isOpened ? '-opened' : ''}`"
            icon-color="#323232"
            icon="arrow-down1"
          />
        </div>
        <transition name="slide-down">
          <div
            v-if="isOpened"
            class="options"
          >
            <div
              v-for="option in filteredOptions"
              :key="option.value"
              class="option"
              :value="option.value"
              @click="chooseOption(option)"
            >
              {{ option.label }}
            </div>
          </div>
        </transition>
      </div>
    </div>
    <div class="k-dropdown-feedback">
      <span v-if="error">
        {{ errorMessage }}
      </span>
    </div>
  </div>
</template>

<script>
import KIcon from './KIcon.vue'
export default {
  directives: {
    'click-outside': {
      bind: function (el, binding) {
        const handler = (e) => {
          if (!el.contains(e.target) && el !== e.target) {
            binding.value(e)
          }
        }
        el.__vueClickOutside__ = handler

        document.addEventListener('click', handler)
      },

      unbind: function (el) {
        document.removeEventListener('click', el.__vueClickOutside__)
        el.__vueClickOutside__ = null
      }
    }
  },
  components: {
    KIcon
  },
  props: {
    label: String,
    options: Array,
    value: String,
    placeholder: {
      type: String,
      default: ''
    },
    required: {
      type: Boolean,
      default: false
    },
    hasError: {
      type: Boolean,
    },
    errorMessage: {
      type: String,
      default: 'Erro!'
    }
  },
  data () {
    return {
      touched: false,
      isOpened: false,
      search: '',
      choosedOption: ''
    }
  },
  computed: {
    error () {
      if (this.hasError) return this.hasError
      return this.touched && this.requiredValidation
    },
    errorMsg () {
      if (this.hasError) return this.errorMessage
      else if (this.required) return 'Campo obrigatório!'
      else return ''
    },
    requiredValidation () {
      return this.required && this.choosedOption === ''
    },
    filteredOptions () {
      const filtered = this.options.filter(option => {
        if (this.improveResults(option.label).includes(this.improveResults(this.search))) return option
      })
      return filtered
    }
  },
  watch: {
    isOpened: {
      handler: function () {
        if (!this.isOpened) this.search = ''
      }
    }
  },
  created () {
    if (this.value && this.value.length > 0) this.getSelectedOption(this.value)
  },
  methods: {
    handleClick () {
      this.touched = false
      this.isOpened = !this.isOpened
      if (this.isOpened) this.$nextTick(() => this.$refs.search.focus())
    },
    chooseOption (option) {
      this.touched = true
      this.$emit('input', option.value)
      this.choosedOption = option.label
      this.isOpened = false
    },
    handleFocusOut () {
      if (this.isOpened) {
        this.isOpened = false
        this.touched = true
      }
    },
    improveResults (text) {
      const removeAccent = text.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      return removeAccent.toLowerCase()
    },
    getSelectedOption (value) {
      const selectedOption = this.options.find(option => option.value === value)
      if (selectedOption !== undefined) this.choosedOption = selectedOption.label
    }
  }
}
</script>

.<style lang="scss" scoped>
@import "@/assets/scss/main.scss";;
.k-dropdown {
  background-color: #ffffff;
  border-radius: 5px;
  box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.08);
  width: 458px;
  height: 60px;
  padding: 3px 0px;
  @media screen and (max-width: 850px) {
    width: unset;
  }
}
.c-select-container {
  position: relative;
  width: 100%;
  .not-display {
    display: none;
  }
  > .c-select {
    cursor: pointer;
    .error-message {
      justify-content: flex-start;
      display: flex;
      align-items: center;
      font-size: 11px;
      color: $primary-6;
      > .icon {
        margin-top: 0px;
        margin-right: 5px;
        fill: $primary-6;
        font-weight: bold;
      }
    }
  }
  > .slide-down-enter-active {
    transition: all 0.3s ease;
  }
  > .slide-down-leave-active {
    transition: all 0.8s cubic-bezier(1, 0.5, 0.8, 1);
  }
  > .slide-down-enter,
  .slide-down-leave-to {
    transform: translateY(-30px);
    opacity: 0;
  }
  > .options {
    position: absolute;
    top: 57px;
    z-index: 4;
    background: white;
    width: 100%;
    border-radius: 0 0 5px 5px;
    transition: all ease 0.2s;
    max-height: 15rem;
    overflow: auto;
    box-shadow: 0 4px 5px 0 rgba(0, 0, 0, 0.08);
    text-transform: uppercase;
    @include body-4;
    color: #5E6684;
    .option {
      padding: 25px 20px;
      text-align: left;
      cursor: pointer;
      transition: all ease 0.3s;
      &:hover {
        background: rgba($neutral-1, 0.05);
      }
    }
    .option + .option {
      border-top: 1px solid $neutral-1-hover;
    }
  }
}
.c-select-container + .c-select-container {
  z-index: 2;
}
.c-select {
  padding: 20px;
  position: relative;
  z-index: 3;
  display: flex;
  align-items: center;
  justify-content: space-between;
  .error-message {
    position: static;
  }
  .content {
    width: 100%;
    display: contents;
    .label {
      text-transform: uppercase;
      color: rgba($neutral-1, 0.5);
      font-size: 11px;
      font-weight: 600;
    }
    .false-placeholder {
      position: absolute;
      z-index: -1;
      left: 116px;
      top: 20px;
      font-weight: bold;
      text-transform: uppercase;
      font-size: 10px;
      color: rgba($neutral-1, 0.5);
    }
  }
  .icon {
    transition: all ease 0.3s;
    &.-opened {
      transform: rotate(180deg);
    }
  }
  .dropdown-button {
    width: 85%;
    text-align: left;
    background-color: transparent;
    border: none;
    @include body-4;
    text-transform: uppercase;
    color: #5E6684;
    font-size: 11px;
    cursor: pointer;
    padding-left: 6rem;
    position: absolute;
    -webkit-appearance: none !important;

    &.-placeholder {
      font-size: 10px;
      color: rgba($neutral-1, 0.5);
    }
  }
  .dropdown-button:focus {
    outline: none !important;
  }
}
.-error {
  box-shadow: $primary-6 0px 0px 5px 0px;
  & ::placeholder {
    color: $primary-6;
  }
}
.k-dropdown-feedback {
  margin-top: 8px;
  margin-left: 8px;
  height: 15px;
  display: flex;
  justify-content: flex-start;
  font-size: 12px;
  color: #FF5967;
}
</style>



// WEBPACK FOOTER //
// src/components/KaledoComponents/KDropdown.vue